import { setPathLocale, stripPathLocale } from '../../common/localeShared';
import { getGameConfig } from '../../gameConfig';
import { commonRoutes } from '../../gameConfig/commonRoutes';
import { TRouter } from '../libs/router/types';
import advertisingService from '../services/advertisingService';

export interface IClientFrontend {
  init(store: any, router: TRouter): void;
}

function isPolicyPage(path: string) {
  if (path.indexOf('/settings/') === 0) {
    return true;
  }

  return (
    [
      commonRoutes.PoliciesUpdated,
      commonRoutes.TermsOfService,
      commonRoutes.PrivacyPolicy,
      commonRoutes.CookiesPolicy
    ].indexOf(path) !== -1
  );
}

let ignoreNextHistoryReplace = false;

export function setIgnoreNextHistoryReplace(ignore: boolean) {
  ignoreNextHistoryReplace = ignore;
}

const clientFrontend: IClientFrontend = {
  init(store: any, router: TRouter) {
    const initialState = store.getState();

    const getCurrentLocaleCode = () => {
      const currentState = store.getState();
      return currentState?.localeConfig?.code || 'en';
    };

    advertisingService.init(initialState, getGameConfig<any>().Routes);

    //
    // history
    //
    let previousPath: string | null = null;

    // from: https://github.com/ReactTraining/react-router/issues/2144#issuecomment-153899046
    router.subscribe((state) => {
      if (
        initialState.auth &&
        initialState.auth.changedPolicies &&
        initialState.auth.changedPolicies.length > 0 &&
        !isPolicyPage(stripPathLocale(window.location.pathname))
      ) {
        router.navigate(setPathLocale(commonRoutes.PoliciesUpdated, getCurrentLocaleCode()), { replace: true });
      }

      // Use setTimeout to make sure this runs after React Router's own listener
      setTimeout(() => {
        // Keep default behavior of restoring scroll position when user:
        // - clicked back button
        // - clicked on a link that programmatically calls `history.goBack()`
        // - manually changed the URL in the address bar (here we might want
        // to scroll to top, but we can't differentiate it from the others)
        if (state.historyAction === 'POP') {
          return;
        }

        if (state.location.state?.disableScroll) {
          return;
        }

        // In all other cases, check fragment/scroll to top
        const hash = window.location.hash;
        if (hash) {
          // ignore key=value pairs, and just find the barewords... use the first one corresponding to element on page
          const parts = hash
            .substr(1)
            .split(':')
            .filter((part) => part.indexOf('=') === -1);
          for (const part of parts) {
            const element = document.querySelector('#' + part);
            if (element) {
              element.scrollIntoView({ block: 'start', behavior: 'smooth' });
              break;
            }
          }
        } else {
          window.scrollTo(0, 0);
        }
      }, 0);

      if (!previousPath || previousPath !== window.location.pathname) {
        previousPath = window.location.pathname;

        const doNotTrackPageChange = state.historyAction === 'REPLACE' && ignoreNextHistoryReplace;

        ignoreNextHistoryReplace = false;

        if (!doNotTrackPageChange) {
          if (typeof gtag === 'function' && typeof gtagConfig === 'function') {
            gtagConfig({
              page_path: location.pathname,
              send_page_view: false
            });
            gtag('event', 'page_view', {
              page_location: window.location.origin + location.pathname,
              page_path: location.pathname
            });
          }
        }

        advertisingService.onPageChanged(previousPath, location.pathname);

        const { aclreSetNewURL, aclrePlayerMoved } = window as any;
        if (aclreSetNewURL && aclrePlayerMoved) {
          aclrePlayerMoved();
          aclreSetNewURL(window.location.origin + location.pathname);
        }
      }
    });

    if (initialState.auth && initialState.auth.changedPolicies) {
      if (initialState.auth.changedPolicies.length > 0 && !isPolicyPage(stripPathLocale(window.location.pathname))) {
        router.navigate(setPathLocale(commonRoutes.PoliciesUpdated, getCurrentLocaleCode()), { replace: true });
      } else if (
        initialState.auth.changedPolicies.length === 0 &&
        stripPathLocale(window.location.pathname) === commonRoutes.PoliciesUpdated
      ) {
        router.navigate(setPathLocale(commonRoutes.Home, getCurrentLocaleCode()), { replace: true });
      }
    }
  }
};

export default clientFrontend;
